const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量影视资源',
    desc: '电影、电视剧、综艺、动漫全覆盖，20万+资源持续扩充中，找片不愁。',
    color: 'primary',
  },
  {
    icon: 'ri-4k-line',
    title: '高清流畅播放',
    desc: '支持多线路自动切换，1080P高清画质，拒绝卡顿缓冲，畅享丝滑观影。',
    color: 'accent',
  },
  {
    icon: 'ri-calendar-todo-line',
    title: '每日准时更新',
    desc: '追剧日历同步更新，热门剧集上架第一时间通知，不错过每一集精彩。',
    color: 'primary',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '完全免费观看',
    desc: '无需会员、无需付费、无需注册，打开浏览器即点即看，真正的免费影视大全。',
    color: 'accent',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步体验',
    desc: '手机、平板、电脑、电视全设备支持，随时随地继续观看，追剧不间断。',
    color: 'primary',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            平台优势
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            为什么选择91影视看片下载
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            五大核心优势，为您打造极致的免费在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feature, idx) => {
            const isPrimary = feature.color === 'primary';
            return (
              <div
                key={idx}
                className="group flex flex-col items-center text-center p-6 bg-background-100 rounded-xl transition-all duration-300"
              >
                <div
                  className={`w-14 h-14 rounded-xl flex items-center justify-center mb-4 transition-colors ${
                    isPrimary
                      ? 'bg-primary-100 group-hover:bg-primary-200'
                      : 'bg-accent-100 group-hover:bg-accent-200'
                  }`}
                >
                  <i
                    className={`${feature.icon} text-xl w-5 h-5 flex items-center justify-center ${
                      isPrimary ? 'text-primary-600' : 'text-accent-600'
                    }`}
                  ></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{feature.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}